import { Button } from '@/components/ui/button';
import ConfirmationDialog from '@/components/ui/dialog-wrapper/ConfirmationDialog';
import { Separator } from '@/components/ui/separator';
import { toastSomethingError } from '@/components/ui/toast-content';
import { IS_DEV, PATH_CONTACT } from '@/constants';
import { RouteParams } from '@/router/type';
import { useDeleteDedicateInstance } from '@/service/one-click-deploy/hook';
import { TrashIcon } from '@radix-ui/react-icons';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useGetDedicateInstanceById } from '../hook/useGetDedicateInstanceById';
import { StatusGetInstances } from '@/service/one-click-deploy/type';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { ServerOffIcon } from 'lucide-react';

const OneClickDeployDetailSetting = () => {
  const { instanceId } = useParams<RouteParams>();
  const { data } = useGetDedicateInstanceById();
  const deleteInstance = useDeleteDedicateInstance({
    onSuccess: () => {
      toast('Instance terminated successfully');
    },
    onError: () => {
      toastSomethingError();
    },
  });
  const handleTerminateInstance = () => {
    deleteInstance.mutate({ instance_id: instanceId!, is_dry_run: IS_DEV });
  };
  const isDisabledTerminateInstance =
    deleteInstance?.isPending ||
    data?.status === StatusGetInstances.Initial ||
    data?.status === StatusGetInstances.Terminated;
  return (
    <>
      <p className="text-base font-semibold">Setting</p>
      <Separator className="my-2" />

      <div className="mt-4">
        {data?.status === StatusGetInstances.Terminated ? (
          <>
            <Alert variant="default">
              <ServerOffIcon className="h-4 w-4" />
              <AlertTitle>Terminated</AlertTitle>
              <AlertDescription>
                This instance has been terminated.
              </AlertDescription>
            </Alert>
          </>
        ) : (
          <>
            <div className="mt-2">
              <p className="font-semibold">Terminated this Instance</p>
              <p>
                Once you terminated a instance, there is no going back. Please
                be certain.
              </p>
              <ConfirmationDialog
                title="Terminated Instance"
                message="Are you sure you want to terminated this instance?"
                onConfirm={handleTerminateInstance}
                confirmText="Delete"
                isCancel={false}
                slots={{
                  confirmButton: {
                    variant: 'destructive',
                    className: 'w-full',
                  },
                }}
              >
                <Button
                  variant="destructive"
                  className="mt-2"
                  startIcon={<TrashIcon />}
                  disabled={isDisabledTerminateInstance}
                >
                  Terminated Instance
                </Button>
              </ConfirmationDialog>
            </div>
          </>
        )}
        {deleteInstance?.isError && (
          <>
            <Alert variant="destructive" className="mt-4">
              <ServerOffIcon className="h-4 w-4" />
              <AlertTitle>Something went wrong.</AlertTitle>
              <AlertDescription>
                Please{' '}
                <Link to={PATH_CONTACT.support} className="underline">
                  contact.
                </Link>
              </AlertDescription>
            </Alert>
          </>
        )}
      </div>
    </>
  );
};

export default OneClickDeployDetailSetting;
